<template lang="pug">
.daterange(@keyup.esc="showCalendar=false", style="margin-left:5px")
  input(type="text", v-model="dateRange", @click.prevent="showCalendar=true", readonly="true")
  i.fa.fa-calendar
  .calendar-wrap(v-show="showCalendar")
    .datespan.clearfix
      span.start 开始日期
      span.end 结束日期
    calendar(ref="calendar", v-model="start", :min-date="minDate", :max-date="maxDate", :pattern="pattern", @update="updateStart")
    calendar(ref="calendar", v-model="end", :min-date="end", :max-date="end", :pattern="pattern", type="end")
    .range-str {{range}}
    .operations
      button.btn.btn-primary(@click.prevent="updateRange") 确定
      button.btn.btn-default(@click.prevent="showCalendar=false") 取消
</template>

<comment>
  <!-- 为啥要改成 pug 呢 因为 HTML 生成的代码中存在讨厌的空格
  <div class="daterange" @keyup.esc="showCalendar=false">
    <input type="text" v-model="dateRange" @click.prevent="showCalendar=true" readonly style="margin-left:5px"/>
    <div v-show="showCalendar" class="calendar-wrap">
      <div class="datespan clearfix"><span class="start">开始日期</span> <span class="end">结束日期</span></div>
      <calendar ref="calendar" v-model="start" :min-date="minDate" :max-date="maxDate" :pattern="pattern" @update="updateStart"></calendar><calendar ref="calendar" v-model="end" :min-date="end" :max-date="end" :pattern="pattern" type="end"></calendar>
      <div class="range-str">{{range}}</div>
      <div class="operations">
        <button class="btn btn-primary" @click.prevent="updateRange">确定</button>
        <button class="btn btn-default" @click.prevent="showCalendar=false">取消</button>
      </div>
    </div>
  </div>
  !-->
</comment>

<script>
import Calendar from 'v-tags/components/calendar/index.vue'

export default {
  name: 'v-date-custom',
  props: {
    startDate: String,
    endDate: String,
    deltaDay: {
      type: Number,
      default: 7
    },
    minDate: {
      type: String,
      default: '1970-01-01'
    },
    maxDate: {
      type: String,
      default: '2099-12-31'
    },
    pattern: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Calendar
  },
  data() {
    return {
      showCalendar: false,
      start: new Date().format(this.pattern)
    }
  },
  computed: {
    dateRange() {
      return (this.startDate && this.endDate) ? `${this.startDate} 至 ${this.endDate}` : '';
    },
    range() {
      return (this.start && this.end) ? `${this.start} 至 ${this.end}` : '';
    },
    end() {
      return this.start ? new Date(new Date(this.start).getTime() + this.deltaDay*24*60*60*1000).format(this.pattern) : ''
    }
  },
  watch: {
    show(val) {
      this.showCalendar = val;
    },
    maxDate() {
      this.start = new Date(this.maxDate).format(this.pattern)
    }
  },
  mounted() {
    //用minDate反推当前时间
    this.start = this.startDate ? new Date(this.startDate).format(this.pattern) : new Date(new Date(this.minDate).getTime() + 365*24*60*60*1000 - this.deltaDay*24*60*60*1000).format(this.pattern);
    this.showCalendar = this.show;
    window.addEventListener('click', this.hideCalendar, false);
  },
  methods: {
    hideCalendar() {//隐藏日期panel
      if(!this.$el.contains(event.target)){
        this.showCalendar = false;
      }
    },
    getDate(day) {
      var today = new Date(),
        todayTime = today.getTime(),
        oneday = 24*60*60*1000;
      return new Date(todayTime - day*oneday).format(this.pattern);
    },
    updateStart(date) {
      this.start = date;
    },
    updateRange() {
      this.$emit('update', {startDate: this.start, endDate:this.end});
      this.showCalendar = false;
    }
  },
  beforeDestroy() {//将点击页面上其他地方关闭日期panel的事件移除
    window.removeEventListener('click', this.hideCalendar);
  }
}
</script>



// WEBPACK FOOTER //
// datepicker-custom.vue?490bcaf0